import React from 'react';
import SbEditable from 'storyblok-react';
import styled from 'styled-components';

import Components from '../components';

const AccentCard = (props) => {
  return (
    <SbEditable content={props.blok}>
      <Card height={props.blok.height}>
        <Left bgColor={props.blok.left_bg_color.color}>
          {props.blok.left.map((blok) =>
            React.createElement(Components(blok.component), { key: blok._uid, blok: blok })
          )}
        </Left>
        <Right bgColor={props.blok.right_bg_color.color}>
          {props.blok.right.map((blok) =>
            React.createElement(Components(blok.component), { key: blok._uid, blok: blok })
          )}
        </Right>
      </Card>
    </SbEditable>
  );
};

const Card = styled.div`
  display: flex;
  flex-flow: row;
  min-height: ${(props) => (props.height && props.height > 0 ? props.height + 'rem' : 'auto')};
`;

const Left = styled.div`
  background-color: ${(props) => props.bgColor};
  border-radius: 2rem 0 0 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  width: 50%;
`;

const Right = styled.div`
  background-color: ${(props) => props.bgColor};
  border-radius: 0 2rem 2rem 0;
  padding: 1rem;
  width: 50%;
`;

export default AccentCard;
